module.exports = __webpack_public_path__ + "img/FixedDoubleOpenA.c54adb4d.png";